export default "__VITE_PUBLIC_ASSET__d8b8967b__"